export const debounce = (cb, interval) => {
  let lastTimeout = null;

  return function() {
    const args = arguments;
    if (lastTimeout) {
      clearTimeout(lastTimeout);
    }
    lastTimeout = window.setTimeout(() => cb.apply(null, args), interval);
  };
};

const getRandomValue = max => Math.floor(Math.random() * max);

export const getRandomColor = alpha =>
  `rgba(${getRandomValue(255)},${getRandomValue(255)},${getRandomValue(
    255
  )},${alpha})`;

export const downloadFile = file => {
  const link = document.createElement("a");
  link.setAttribute("download", file.name);
  link.setAttribute("target", "_blank");
  link.setAttribute("href", `${file.href}`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const isEmpty = string => {
  return !string || !string.trim();
};

export const capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
